ixModuleRouting('impactx.rfxsupplier', {
    '/rfxsupplierlist': {
        template: "<ixa-rfx-supplier-list></ixa-rfx-supplier-list>",
        templateUrl: 'modules/rfxsupplier/templates/rfxsupplierlist.html',
        process: "RFXSupplierView",
        controller: 'RFXSupplierListCtrl',
        controllerAs: 'rfxSupplierListCtrl',
        workspace: 'shop'
    },

    '/rfxsupplier/view/:id?': {
        template: "<ixa-rfx-supplier-view></ixa-rfx-supplier-view>",
        templateUrl: 'modules/rfxsupplier/templates/rfx-supplier-view.html',
        process: "RFXSupplierView",
        controller: 'RFXSupplierViewCtrl',
        controllerAs: 'rfxSupplierViewCtrl',
        workspace: 'shop'
    },

    '/rfxsupplier/edit/:id': {
        template: '<ixa-rfx-supplier-edit></ixa-rfx-supplier-edit>',
        templateUrl: 'modules/rfxsupplier/templates/rfx-supplier-edit.html',
        process: "RFXSupplierView",
        controller: 'RFXSupplierEditCtrl',
        controllerAs: 'rfxSupplierEditCtrl',
        workspace: 'shop'
    },
    '/rfxsupplier/edit/:id/:productIdToAdd/:cscIdForProductToAdd?/:amountToAdd?': {
        template: '<ixa-rfx-supplier-edit></ixa-rfx-supplier-edit>',
        templateUrl: 'modules/rfxsupplier/templates/rfx-supplier-edit.html',
        process: "RFXSupplierView",
        controller: 'RFXSupplierEditCtrl',
        controllerAs: 'rfxSupplierEditCtrl',
        workspace: 'shop'
    },
    '/rfxsuppliereditbuyer/:rfqhId/:id': {
        template: '<ixa-rfx-supplier-edit></ixa-rfx-supplier-edit>',
        templateUrl: 'modules/rfxsupplier/templates/rfx-supplier-edit.html',
        process: "RFXSupplierViewForBuyer",
        controller: 'RFXSupplierEditCtrl',
        controllerAs: 'rfxSupplierEditCtrl',
        workspace: 'shop'
    },

    '/rfxsuppliereditbuyer/:rfqhId/:id/:productIdToAdd/:cscIdForProductToAdd?/:amountToAdd?': {
        template: '<ixa-rfx-supplier-edit></ixa-rfx-supplier-edit>',
        templateUrl: 'modules/rfxsupplier/templates/rfx-supplier-edit.html',
        process: "RFXSupplierViewForBuyer",
        controller: 'RFXSupplierEditCtrl',
        controllerAs: 'rfxSupplierEditCtrl',
        workspace: 'shop'
    },
});